import { render, staticRenderFns } from "./ArticoloSearchModal.vue?vue&type=template&id=b52407c0&scoped=true&"
import script from "./ArticoloSearchModal.vue?vue&type=script&lang=js&"
export * from "./ArticoloSearchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52407c0",
  null
  
)

export default component.exports